import { memo } from 'react';

import { HTMLParser, PageTitle } from 'containers';
import { FiltersBar, ControlWrapper, Download } from 'components';

import { useStyles } from './style';

interface Props {
  fileName: string;
  url: string;
}

const InvestorLiabilitiesDetails: React.FC<Props> = ({ fileName, url }) => {
  const classes = useStyles();

  return (
    <>
      <PageTitle />
      <FiltersBar className={classes.filtersBar}>
        <ControlWrapper>
          <Download name={fileName} url={`${url}?download=true`} />
        </ControlWrapper>
      </FiltersBar>
      {url ? <HTMLParser url={url} /> : null}
    </>
  );
};

export default memo(InvestorLiabilitiesDetails);
